import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';

class ImageSphere extends BasicComponent {
    getType() { return "Image"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        const base = super.construct(context, prefab).getRootNode();
        console.log("context variable:",context);
        console.log("context.$store.getters.mediaURL:",context.$store.getters.mediaURL);
        
        this.prefab = prefab;
        this.context = context;

        let photoDome_base = new BABYLON.PhotoDome("SituationImage_"+ this.prefab.getSphereImageID(), "",{ 
            resolution:32,
            faceForward: false,
            size: 400  
        }, window.scene);
        photoDome_base.parent = base;

        let photoDome_overlay = new BABYLON.PhotoDome("SituationImage_"+ this.prefab.getSphereImageID() + "_Overlay", "",{ 
            resolution: 32,
            faceForward: false,
            size: 398  
        }, window.scene);
        photoDome_overlay.parent = base;
        photoDome_overlay.mesh.isPickable = false;
        
        if(this.context.activeLanguage){
            photoDome_base.photoTexture = this.getPanoramaBase(); 
            photoDome_overlay.photoTexture = this.getPanoramaOverlay(); 
        }

        window.addEventListener("languageChange", () => {
            photoDome_base.photoTexture = this.getPanoramaBase(); 
            photoDome_overlay.photoTexture = this.getPanoramaOverlay(); 
        });

        return base;
    }

    getPanoramaBase(){
        let panoramaPhoto;

        let roomName = this.prefab.name.split("_")[0];
        this.context.allPrefabs.forEach((prefab) => {
            if(prefab.sphereImageID && (roomName + "_base") == prefab.name){
                const panoramaPhotoMedia = MediaManager.getMedia(prefab.getSphereImageID());
                let photoDomeTexture = BABYLON.RawTexture.CreateRGBATexture(panoramaPhotoMedia.blob, panoramaPhotoMedia.blob.width, panoramaPhotoMedia.blob.height, window.scene, true, true, BABYLON.Texture.TRILINEAR_SAMPLINGMODE);
                photoDomeTexture.wrapU = photoDomeTexture.wrapV = BABYLON.Constants.WRAP_ADDRESSMODE;
                photoDomeTexture.name = panoramaPhotoMedia.id;
                panoramaPhoto = photoDomeTexture;
            }
        });

        return panoramaPhoto;
    }

    getPanoramaOverlay(){
        let panoramaPhoto;

        let langCode = this.context.activeLanguage.shortCode;
        let roomName = this.prefab.name.split("_")[0];

        console.log("Searching for matching language-overlay for '"+ roomName +"' width language '"+langCode+"'");

        this.context.allPrefabs.forEach((prefab) => {
            if(prefab.sphereImageID){
                if(prefab.name.charAt(0) == " "){
                    prefab.name = prefab.name.substring(1);
                }
                this.context.languages.forEach(language => {
                    if(langCode == language.shortCode && (roomName + "_" + language.shortCode + "NEW") == prefab.name){
                        console.log("Found matching prefab (overlay)",prefab);
                        panoramaPhoto = MediaManager.getMedia(prefab.getSphereImageID());
                        let photoDomeTexture = BABYLON.RawTexture.CreateRGBATexture(panoramaPhoto.blob, panoramaPhoto.blob.width, panoramaPhoto.blob.height, window.scene, true, true, BABYLON.Texture.TRILINEAR_SAMPLINGMODE);
                        photoDomeTexture.wrapU = photoDomeTexture.wrapV = BABYLON.Constants.WRAP_ADDRESSMODE;
                        photoDomeTexture.name = panoramaPhoto.id;
                        panoramaPhoto = photoDomeTexture;
                    }
                });
            }
        });
        if(!panoramaPhoto || panoramaPhoto == null){
            console.log("ERROR cannot find matching prefab (overlay)");
        }

        panoramaPhoto.hasAlpha = true;
        return panoramaPhoto;
    }
}

export default ImageSphere;

